import { FunctionComponent } from "react";

import "./NavbarDivider.scss";

export const NavbarDivider: FunctionComponent = () => {
  return <div className="navbar-divider" />;
};
